import { Dialog, DialogContent, Grid } from '@mui/material'
import dayjs from 'dayjs'
import { useCallback, useContext, useEffect, useState } from 'react'
import { metodoPrograma } from '../../../../../../components/api'
import { setSuccess } from '../../../../../../components/alerts'
import { GlobalContext } from '../../../../../../App'
import HeaderEvolucao from './evolucao/HeaderEvolucao'
import ListaEvolucao from './evolucao/ListaEvolucao'
import FormEvolucao from './evolucao/FormEvolucao'

const ModalEvolucaoPaciente = ({ data, close }) => {
  const { usuarioLogado } = useContext(GlobalContext)
  const somenteVisualizacao = Number(usuarioLogado?.id) === 45
  const [lista, setLista] = useState([])
  const [idAtivo, setIdAtivo] = useState(null)
  const [loading, setLoading] = useState(false)
  const [nmPaciente, setNmPaciente] = useState('')

  const carregarPaciente = useCallback(async () => {
    if (!data.idPaciente) return
    const res = await metodoPrograma(
      'getPaciente',
      { idPaciente: data.idPaciente },
      'CtrlProgramacaoAgendaCheckin',
    )
    if (res?.nmPaciente) {
      setNmPaciente(res?.nmPaciente || '')
    }
  }, [data.idPaciente])

  const carregar = useCallback(async () => {
    setLoading(true)
    const res = await metodoPrograma('listaEvolucaoEnfermagem', {
      idPaciente: data.idPaciente,
    })
    const novaLista = res?.lista || []
    setLista(novaLista)
    if (somenteVisualizacao) {
      setIdAtivo(novaLista[0]?.[0] || null)
    }
    setLoading(false)
    return novaLista
  }, [data.idPaciente, somenteVisualizacao])

  useEffect(() => {
    carregarPaciente()
    carregar()
  }, [carregarPaciente, carregar])

  const onSalvar = async (values) => {
    if (somenteVisualizacao) return

    const res = await metodoPrograma('registraEvolucaoEnfermagem', {
      idPaciente: data.idPaciente,
      dtEvolucao: dayjs(values.dtEvolucao).format('YYYY-MM-DD HH:mm:ss'),
      dsEvolucao: values.dsEvolucao,
      vlAltura: values.vlAltura ? Number(values.vlAltura) : null,
      vlPeso: values.vlPeso ? Number(values.vlPeso) : null,
      nrTemperatura: values.nrTemperatura ? Number(values.nrTemperatura) : null,
      nrFrequenciaRespiratoria: values.nrFrequenciaRespiratoria
        ? Number(values.nrFrequenciaRespiratoria)
        : null,
      nrFrequenciaCardiaca: values.nrFrequenciaCardiaca
        ? Number(values.nrFrequenciaCardiaca)
        : null,
      nrPASistolica: values.nrPaSistolica ? Number(values.nrPaSistolica) : null,
      nrPADiastolica: values.nrPaDiastolica
        ? Number(values.nrPaDiastolica)
        : null,
    })
    if (!res?.dsErro) {
      setSuccess('Evolução registrada com sucesso')
      const novaLista = await carregar()
      setIdAtivo(novaLista[0]?.[0] || null)
    }
  }

  const ativo = lista.find((item) => item?.[0] === idAtivo) || null

  return (
    <Dialog open={true} maxWidth="xl" fullWidth onClose={() => close()}>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <HeaderEvolucao paciente={{ ...data, nmPaciente }} ativo={ativo} />
          </Grid>
          {/* <Grid item xs={12}>
            <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', py: 1 }}>
              <Chip
                icon={<MdAddCircle />}
                label="Nova Evolução"
                color={idAtivo === null ? 'primary' : 'default'}
                onClick={() => setIdAtivo(null)}
              />
              {lista.map((item) => (
                <Chip
                  key={item?.[0]}
                  label={`${dayjs(item?.[4]).format('HH:mm')} - ${item?.[1]?.[1] || '---'}`}
                  color={item?.[0] === idAtivo ? 'primary' : 'default'}
                  onClick={() => setIdAtivo(item?.[0])}
                />
              ))}
            </Box>
          </Grid> */}
          <Grid item xs={12} md={4}>
            <ListaEvolucao
              lista={lista}
              idAtivo={idAtivo}
              onSelecionar={(id) => setIdAtivo(id)}
              onNovo={() => setIdAtivo(null)}
              permiteNovo={!somenteVisualizacao}
              loading={loading}
            />
          </Grid>
          <Grid item xs={12} md={8}>
            <FormEvolucao
              ativo={ativo}
              onSalvar={onSalvar}
              somenteVisualizacao={somenteVisualizacao}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}

export default ModalEvolucaoPaciente
